import React from 'react';
import classNames from 'classnames';

import style from './ClaimsTable.scss';

type ClaimsTableProps = {
  children: React.ReactNode;
  showConsumerActionStatus: boolean;
};

function ClaimsTable({ children, showConsumerActionStatus }: ClaimsTableProps) {
  return (
    <table
      className={classNames(style['claims-table'], {
        [style['without-consumer-action-status-column']]: !showConsumerActionStatus,
      })}
    >
      {children}
    </table>
  );
}

export default ClaimsTable;
